module.exports = __webpack_public_path__ + "img/logos_customer_02.c31d0bd9.svg";